<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:300vh"
      variant="dark"
      id="loader"
    >
    <b-row>
      <b-col cols="12 headerF"><HeaderFixed/></b-col>
      <b-col cols="12 headerM"><HeaderMobile/></b-col>
    </b-row>
      <b-container id="" fluid style="padding-top: 100px;text-align:left">

        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        Home
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>Amicable Settlement Scheme</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <div class="title">Amicable One-Time Settlement Scheme</div>

        <div>
          <b-tabs content-class="mt-3"  v-model="tabIndex">

    <b-tab title="" disabled>

        <div class="paddingLeft30px">
          <b-row>
          <b-col cols=12>
              <span class="heading">Applicant Details :</span>
          </b-col>
        </b-row>
          <hr/>
          <!-- <br>
          <p style="color:red">We are facing some technical issues with our payment gateway. This is expected to be resolved soon. Sorry for the inconvenience.</p> -->
          <b-row class="paddingRow">
             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">Consumer Account No <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="text" id="consNo" placeholder="Consumer Account No" value="" trim  @change="showDetails()"/>
             </b-col>

             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label"> Name of the Consumer <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="text" id="consName" placeholder="Name of the Consumer" trim />
             </b-col>
           </b-row>



            <b-row class="paddingRow">
             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">Correspondence Address <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <!-- <b-form-input type="text" id="address" placeholder="Correspondence Address" trim /> -->
                <b-textarea  type="text" id="address" placeholder="Correspondence Address" trim />
             </b-col>

             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label"> Designated Email ID <span class="text-danger">*</span>  :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="email" id="email" placeholder="Email ID" trim />
             </b-col>
            </b-row>

             <b-row class="paddingRow">
            <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label"> Contact Mobile No <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="number" id="mobileNo" placeholder="Mobile No" trim />
             </b-col>

            <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">WhatsApp Contact <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="number" id="whatsappNo" placeholder="WhatsApp Number" trim />
             </b-col>
           </b-row>

           <b-row class="paddingRow">
            <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">Last bill reference <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="text" id="lastBillNo" placeholder="Last bill reference" trim />
             </b-col>

            <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">Amount Outstanding(as on date of application) <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="number" id="outstandingAmt" placeholder="Amount outstanding" trim />
             </b-col>
           </b-row>

           <br>
        <div id="" >
          <b-row>
            <b-col cols=12>
                <span class="heading">Application Details :</span>
            </b-col>
          </b-row>
          <hr/>
          <b-row class="paddingRow">
            <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">Present status of connection <span class="text-danger">*</span> :</span>
             </b-col>

             <b-col cols="12" sm="12" md="8" lg="8">
                <b-form-radio-group  v-model="connectionStatus">
                  <b-form-radio name="connStatus" value="connected">Connected</b-form-radio>
                  <b-form-radio name="connStatus" value="disconnected">Disconnected</b-form-radio>
                </b-form-radio-group>
             </b-col>

           </b-row>

           <b-row class="paddingRow">
            <b-col cols="12" sm="2" md="2" lg="2" class="paddingCol">
               <span class="label">Case Reference <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="1" md="1" lg="1" class="paddingCol">
               <span class="label">No <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="number" id="caseNo"  trim />
             </b-col>

             <b-col cols="12" sm="1" md="1" lg="1" class="paddingCol">
               <span class="label">Year <span class="text-danger">*</span> :</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3">
               <b-form-input type="number" id="caseYear"  trim />
             </b-col>

           </b-row>

           <b-row class="paddingRow">
             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">Present status of litigation <span class="text-danger">*</span> :</span>
             </b-col>
             <b-form-radio-group  v-model="litigStatus">
               <b-col cols="12" sm="12" md="12" lg="12">
               <b-form-radio type="radio" name="litigationStatus"  value="Honourable Supreme Court of India"   >
               Honourable Supreme Court of India </b-form-radio>
             </b-col>
               <b-col cols="12" sm="12" md="12" lg="12">
               <b-form-radio type="radio" name="litigationStatus"  value="Hon’ble Appellate Tribunal for Electricity"  >
              Hon’ble Appellate Tribunal for Electricity</b-form-radio>
             </b-col>

               <b-col cols="12" sm="12" md="12" lg="12">
               <b-form-radio  type="radio" name="litigationStatus" value="Any of Hon’ble High Court"  >Any of Hon’ble High Court </b-form-radio>
             </b-col>

              <b-col cols="12" sm="12" md="12" lg="12">
               <b-form-radio type="radio" name="litigationStatus" value="Any of District Court" >Any of District Court </b-form-radio>
             </b-col>

              <b-col cols="12" sm="12" md="12" lg="12">
               <b-form-radio type="radio" name="litigationStatus" value="Appellate Authority" > Appellate Authority </b-form-radio>
             </b-col>

              <b-col cols="12" sm="12" md="12" lg="12">
               <b-form-radio type="radio" name="litigationStatus" value="CGRF/Ombudsmen" >CGRF/Ombudsmen </b-form-radio>
             </b-col>

              <b-col cols="12" sm="12" md="12" lg="12" >
                <b-form-radio type="radio" name="litigationStatus" value="Others" >Others</b-form-radio>
             </b-col>
              <b-col cols="12" sm="12" md="12" lg="12" >
                <br>

                <div v-if="litigStatus === 'Others'">
                   <b-form-input type="text" id="litigStatusOther" />
                 </div>

              </b-col>

             </b-form-radio-group>

           </b-row>
           <b-row class="paddingRow">
             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <span class="label">Upload Copy of the latest Order <span class="text-danger">*</span> :</span><br>
             <span style="font-size:0.8rem;color:red">***(Maximum File Size 5Mb)***</span>
             </b-col>
             <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
               <input type="file" id="latestOrderFile"/>
             </b-col>
           </b-row>


          </div>

      </div>

    <br>
    <div class="paddingLeft30px">
      <b-row>
      <b-col cols=12>
          <span class="heading">Detailed Submission:</span>
      </b-col>
    </b-row>
      <hr/>

       <b-row class="paddingRow">
         <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
           <span class="label">a.	Reason(s) for preferring litigation against the bill <span class="text-danger">*</span> :</span>
         </b-col>
         <b-col cols="12" sm="6" md="6" lg="6">
           <b-textarea type="text" id="reason_for_litigation" placeholder="Enter the reason" trim />
         </b-col>
       </b-row>

        <b-row class="paddingRow">
         <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
           <span class="label">b.	Justification in support <span class="text-danger">*</span> :</span>
         </b-col>
         <b-col cols="12" sm="6" md="6" lg="6">
           <b-textarea  type="text" id="justification" placeholder="Enter the reason" trim />
         </b-col>
       </b-row>

        <b-row class="paddingRow">
         <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
           <span class="label">c.	Legal provisions exercised in defence <span class="text-danger">*</span> :</span>
         </b-col>
         <b-col cols="12" sm="6" md="6" lg="6">
           <b-textarea  type="text" id="legal_provision" placeholder="Enter the reason" trim />
         </b-col>
       </b-row>


        <b-row class="paddingRow">
         <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
           <span class="label">d.	Reason(s) for applying under this Amicable One-Time Settlement Scheme <span class="text-danger">*</span> :</span>
         </b-col>
         <b-col cols="12" sm="6" md="6" lg="6">
           <b-textarea  type="text" id="reason_for_settlement" placeholder="Enter the reason" trim />
         </b-col>
       </b-row>



       <b-row class="paddingRow">
         <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
           <span class="label">Select Settlement option <span class="text-danger">*</span> :</span>
         </b-col>
         <b-form-radio-group  v-model="settlementOpt">
           <b-col cols="12" sm="12" md="12" lg="12">
           <b-form-radio type="radio" name="settlementOption"  value="100% upfront payment of principal amount" trim >
             100% upfront payment of principal amount </b-form-radio>
          </b-col>
         <b-col cols="12" sm="12" md="12" lg="12">
           <b-form-radio type="radio" name="settlementOption"  value="75% upfront payment of principal amount" >
             75% upfront payment of principal amount <span style="color:red">(Installment date: 29/09/21)</span></b-form-radio>
         </b-col>

           <b-col cols="12" sm="12" md="12" lg="12">
           <b-form-radio  type="radio" name="settlementOption" value="50% upfront payment of principal amount" >
             50% upfront payment of principal amount <span style="color:red">(Installment dates: 29/09/21,29/10/21)</span> </b-form-radio>
         </b-col>

          <b-col cols="12" sm="12" md="12" lg="12">
           <b-form-radio type="radio" name="settlementOption" value="25% upfront payment of principal amount" trim >
             25% upfront payment of principal amount <span style="color:red">(Installment dates: 29/09/21,29/10/21,29/11/21)</span> </b-form-radio>
         </b-col>
         </b-form-radio-group>



       </b-row>

       <br>
       <b-row class="paddingRow">
       <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
          <span class="label">Applicant Name <span class="text-danger">*</span> :</span>
        </b-col>
        <b-col cols="12" sm="4" md="4" lg="4">
          <b-form-input type="text" id="applicantName" placeholder="Enter Name" trim />
        </b-col>
      </b-row>
       <b-row class="paddingRow">
       <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
          <span class="label">Date <span class="text-danger">*</span> :</span>
        </b-col>
        <b-col cols="12" sm="4" md="4" lg="4">
          <b-form-input type="date" id="date1"  trim />
        </b-col>
      </b-row>
      <b-row class="paddingRow">
       <b-col cols="12" sm="3" md="3" lg="3" class="paddingCol">
          <span class="label">Place <span class="text-danger">*</span> :</span>
        </b-col>
        <b-col cols="12" sm="4" md="4" lg="4">
          <b-form-input type="text" id="place" placeholder="Enter Place" trim />
        </b-col>
      </b-row>
      <br>
       <b-row>
       <b-col cols="12" sm="12" md="12" lg="12" >
         <b-form-checkbox
            id="checkbox"
            v-model="declaration"
            name="checkbox"
            value="accepted"
            unchecked-value="not_accepted"
            @click="enableSubmit()"
          >
       <span>
          I hereby undertake to withdraw the present litigation and not to pursue the matter in any other forum in future.
          I also undertake that in the event of non-compliance to any of the terms of this arrangement at any point of time
          till payment of last instalment, entire amount paid under this scheme will be forfeited and I will have no claim
          over it.
          <br>
          Requisite upfront payment of Rs. <input  type="number" id="paymentAmt" @keyup="numToWord()"/>
          (Rupees <span style="font-weight:600">{{ paymentAmtWord }}</span>)
          is deposited to the designated APDCL Account (Account No. 10566984122 maintained with SBI,
          New Guwahati Branch, IFS Code SBIN0000221) vide [UTR/RTGS/NEFT Reference No.]: <input  type="number" id="paymentRefNo" />
       </span>
         </b-form-checkbox>
        </b-col>
        </b-row>
       <br><br>

      <b-row>
          <b-col cols=12 lg=3 md=3 sm=12  offset-md=5 offset-lg=5>
            <b-button block squared variant="primary" @click="submitFormFinal()" id="submit_button" >
                SUBMIT
            </b-button><br><br>
          </b-col>
      </b-row>

    </div>
      </b-tab>

          <b-tab title="Check Status" active>
            <b-row>
                  <b-col col cols="12" sm="12" md="12" lg="2" style="padding-top: 7px;">
                        <span style="font-weight:600" >Application Number <span class="text-danger">*</span></span>
                  </b-col>
                  <b-col col cols="8" sm="8" md="8" lg="4">
                      <b-form-input type="text"  id="applNo" v-model="applNumber"  placeholder="Enter your Application Number" trim required />
                  </b-col>
                  <b-col col cols="4" sm="3" md="3" lg="1">
                        <b-button @click="showStatus()" block pill variant="primary" size="md" class="go" style="width:100%">
                          <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                        </b-button>

                  </b-col>
             </b-row>

             <div id="statusDetails" class="hideDetails">
                   <b-row>
                     <b-col cols=12>
                        <br><br>
                         <span class="">Your Application ( <strong> Appl No: {{ applNumber }} </strong> ) Status : </span><span id="statusDiv" style="font-size:1.5rem;font-weight:600;color:red"></span>
                         <br><br><br>
                     </b-col>
                   </b-row>
                 </div>

          </b-tab>

        </b-tabs>
      </div>

  </b-container>
  <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
    <span class="data" id="modalMsg"> DEMO </span>
    <br><br>
      <b-button  style="width:8rem" variant="outline-primary" @click="closeModal('model')">OK</b-button>
  </b-modal>
    </b-overlay>

    <b-modal   no-close-on-esc  no-close-on-backdrop   hide-header id="successModal" centered  scrollable title="Complaint Update" hide-footer>
      <br><br><svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
        <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
      </svg>
      <p class="success"> Successfully Saved !<br><br>
       <b-button class="btn btn-outline" variant="success" id="" @click="generatePdf()" >Download Acknowledgement</b-button>
      &nbsp &nbsp  <b-button class="btn btn-outline" variant="danger" id="" @click="closeModalSuccess('successModal');" >Close</b-button>
      </p>
    </b-modal>
    <b-modal  no-close-on-esc  no-close-on-backdrop   hide-header id="failureModal" centered  scrollable title="Complaint Update" hide-footer>
    <br><br>  <svg class="modalFont" version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="-180 0 500 130">
        <circle class="path circle" fill="none" stroke="#D06079" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="34.4" y1="37.9" x2="95.8" y2="92.3"/>
        <line class="path line" fill="none" stroke="#D06079" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" x1="95.8" y1="38" x2="34.4" y2="92.2"/>
      </svg>
      <p class="error">Form Save Failed ! <br><br>
        <b-button class="btn btn-outline" variant="danger" id="" @click="closeModal('failureModal');" >OK</b-button>
         </p>
    </b-modal>
  </div>
</template>

<script>

import HeaderFixed from '@/components/HeaderFixed.vue'
import HeaderMobile from '@/components/HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
const numWords = require('num-words');

import * as pdfMake from 'pdfmake/build/pdfmake';
import * as pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;

//const urlCommon = "http://localhost:8081/website";
//const urlCommon = "https://portald.apdcl.org/website";
//const urlCommon = "https://www.apdcl.org/website";
var applNo="";
var dateTime;
var dataToSend;
export default {
  name: 'AmicableForm',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' :HeaderMobile
    //MarqueeText

  },
  computed: {

  },
  data() {
    return {
      checked: false,
      tabIndex: 1,
      consumerNo: '',
      show: false,
      litigStatus: '',
      connectionStatus:'',
      settlementOpt:'',
      paymentAmtWord:'',
      declaration:'not_accepted',
      applNumber:'',
      message : [
        "",
        "No Consumer Found for this Consumer Number",
        "No Outstanding Bill Found for this Consumer Number",
        "This Consumer Number is Blocked",
        "No Bill Found for Payment",
        "",
        "Server Busy! Kindly Try Again After Sometime.",
        "Transaction Already in Progress",
        "Error in Initiating Payment Request with Billdesk"
      ],
    }
  },
  methods: {

      numToWord()
      {

        var num=   document.getElementById("paymentAmt").value;
        const amountInWords = numWords(num);
        this.paymentAmtWord=amountInWords;
      },

      submitFormFinal() {
        if(document.getElementById("consNo").value === "" || document.getElementById("consName").value === ""
        || document.getElementById("address").value ==="" || document.getElementById("mobileNo").value === ""
        || document.getElementById("email").value ==="" || document.getElementById("whatsappNo").value === ""
        || document.getElementById("lastBillNo").value ==="" || document.getElementById("outstandingAmt").value === ""
        || this.connectionStatus == "" || document.getElementById("caseNo").value == ""
        || document.getElementById("caseYear").value =="" || this.litigStatus==""
        || document.getElementById("latestOrderFile").value ==""
        || document.getElementById("reason_for_litigation").value ==="" || document.getElementById("justification").value === ""
        || document.getElementById("legal_provision").value ==="" || document.getElementById("reason_for_settlement").value === ""
        || this.settlementOption == "" || document.getElementById("applicantName").value == ""
        || document.getElementById("date1").value ==="" || document.getElementById("place").value === ""
        || document.getElementById("paymentAmt").value ==="" || document.getElementById("paymentRefNo").value === ""
        )
        {
          this.$bvToast.toast('Enter All Required Fields !', {
          title: `Error`,
          variant: 'danger',
          solid: true
          });
          return;
        }
        var litigStatusOther="";
        if(this.litigStatus === "Others")
        {
          litigStatusOther = document.getElementById("litigStatusOther").value;
        }
        if(this.declaration === "not_accepted")
        {
          this.$bvToast.toast('Please Accept Declaration !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          document.getElementById("checkbox").focus();
         return;
        }

        if(document.getElementById('latestOrderFile').files[0].size/1024/1024 > 5)
        {
          this.$bvToast.toast('File size must be less than 5Mb !', {
            title: `Alert`,
            variant: 'danger',
            solid: true
          })
          return;
        }

        var formData = new FormData();
        var file = document.querySelector('#latestOrderFile');
        formData.append("consNo", document.getElementById("consNo").value );
        formData.append("uploadfile", file.files[0]);
        console.log(formData)
        //TODO: add loader
            var parent = this;
          parent.show=true;
          //axios.post( this.$urlCommon + "/api/web/saveAmicableForm", dataToSend,formData,{
          axios.post( this.$urlCommon + "/api/web/uploadAmicableFile", formData,{
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }).then(function(response) {
            console.log(response.data)
            parent.show=false;
            if (response.data.status == "success") {
                dataToSend = {
                "cons_no": document.getElementById("consNo").value,
                "cons_name": document.getElementById("consName").value,
                "address":document.getElementById("address").value,
                "email":document.getElementById("email").value,
                "mobile":document.getElementById("mobileNo").value,
                "whatsapp":document.getElementById("whatsappNo").value,
                "last_bill_no":document.getElementById("lastBillNo").value,
                "outstanding_amt": document.getElementById("outstandingAmt").value,
                "conn_status": parent.connectionStatus,
                "litigation_status": parent.litigStatus,
                "litigation_status_other": litigStatusOther,
                "case_no":document.getElementById("caseNo").value,
                "case_year":document.getElementById("caseYear").value,
                "settlement_option":parent.settlementOpt,
                "reason_for_litigation": document.getElementById("reason_for_litigation").value,
                "justification": document.getElementById("justification").value,
                "legal_provision":document.getElementById("legal_provision").value,
                "reason_for_settlement":document.getElementById("reason_for_settlement").value,
                "payment_amt":document.getElementById("paymentAmt").value,
                "applicant_name":document.getElementById("applicantName").value,
                "date":document.getElementById("date1").value,
                "place":document.getElementById("place").value,
                "file_path":response.data.filePath,
                "declaration":parent.declaration,
                "payment_ref":document.getElementById("paymentRefNo").value,
                "settlement_status":"Pending"
              }
              console.log(dataToSend)
              axios.post( parent.$urlCommon + "/api/web/saveAmicableForm", dataToSend).then(function(response) {
                  console.log(response.data)
                  if (response.data.status == "success") {
                    applNo = response.data.applNo;
                    dateTime = response.data.dateTime;
                  parent.$bvModal.show('successModal');
                }
                else {
                      parent.$bvModal.show('failureModal');
                }
              })


            } else {

              parent.$bvModal.show('failureModal');
            }
          })

        },
      closeModal(modal){
        this.$bvModal.hide(modal)
      },
      closeModalSuccess(modal){
        this.$bvModal.hide(modal)
        window.location.reload();
      },

      showDetails() {
        var consNo= document.getElementById("consNo").value;

        var parent=this;
        this.show= true;
        axios.post('https://www.apdclrms.com/cbs/RestAPI/myBijulee/ConsDetails?cons_no='+consNo)
        .then((response) => {
          parent.show= false;
          console.log(response.data);
          var data=response.data;
          var status = data.message;

          if(status=="00")
          {
            document.getElementById("consName").value = data.cons_name;
            document.getElementById("mobileNo").value = data.mobile_no;
            document.getElementById("email").value = data.email;
            document.getElementById("applicantName").value = data.cons_name;

            /*
            axios.post('https://apdclrms.com/cbs/RestAPI/OnlineBill/billData?consNo='+consNo+'&billCount=1')
            .then((response) => {
            console.log(response.data);
              response.data.forEach(element => {
                document.getElementById("lastBillNo").value = element.bill_NO;
                document.getElementById("outstandingAmt").value = element.due_AMOUNT+".00";
            })
          })
          */
          }
          else
          {
            parent.show= false;
            // parent.$bvModal.show('model');
            // document.getElementById("modalMsg").innerHTML=" Consumenr Data Not Found, Enter data Manually";
          }


        })
        .catch((e) => {
        console.log("Caught", e);
        this.show= false;
      })

    },

generatePdf() {
        var docDefinition = {
        pageSize: 'A4',
        pageOrientation: 'portrait',
        content: [
          // { image: '../assets/apdcl_logo.png',  width: 150,  height: 150,},
          { text: 'ACKNOWLEDGEMENT RECEIPT', style: 'header' },
          // { text: 'AMICABLE ONE-TIME SETTLEMENT SCHEME', style: 'header' },
          { text: 'Amicable One-time Settlement Scheme, APDCL', style: 'subheader' },
          { text: 'Application No: '+applNo, style: 'applNo' },
          { text: '- - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -' },

          { text: 'Applicant details:', style: 'heading' },
          {	text: ['Name of the Consumer: ',	{text: dataToSend.cons_name, style: 'boldText'}, ],style: 'normalText'},
          { text: ['Consumer Account No: ', {text: dataToSend.cons_no, style: 'boldText'},], style: 'normalText' },
          { text: ['Correspondence Address: ', {text: dataToSend.address, style: 'boldText'},], style: 'normalText' },
          { text: ['Designated Email ID: ', {text: dataToSend.email, style: 'boldText'},], style: 'normalText' },
          { text: ['Contact mobile No.: ', {text: dataToSend.mobile, style: 'boldText'},], style: 'normalText' },
          { text: ['WhatsApp contact: ', {text: dataToSend.whatsapp, style: 'boldText'},], style: 'normalText' },
          { text: ['Last bill reference: ', {text: dataToSend.last_bill_no, style: 'boldText'},], style: 'normalText' },
          { text: ['Amount outstanding(as on date of application): ', {text: dataToSend.outstanding_amt, style: 'boldText'},], style: 'normalText' },

          { text: '\n\n Application details:', style: 'heading' },
          { text: ['Present status of connection: ', {text: dataToSend.conn_status, style: 'boldText'},], style: 'normalText' },
          { text: ['Case Reference No: ', {text: dataToSend.case_no, style: 'boldText'},], style: 'normalText' },
          { text: ['Case Reference Year: ', {text: dataToSend.case_year, style: 'boldText'},], style: 'normalText' },
          { text: ['Present status of litigation: ', {text: dataToSend.litigation_status, style: 'boldText'},], style: 'normalText' },

          { text: '\n\n Detailed Submission:', style: 'heading' },
          { text: ['Reason(s) for preferring litigation against the bill: ', {text: dataToSend.reason_for_litigation, style: 'boldText'},], style: 'normalText' },
          { text: ['Justification in support: ', {text: dataToSend.justification, style: 'boldText'},], style: 'normalText' },
          { text: ['Legal provisions exercised in defence: ', {text: dataToSend.legal_provision, style: 'boldText'},], style: 'normalText' },
          { text: ['Reason(s) for applying under this Amicable One-Time Settlement Scheme: ', {text: dataToSend.reason_for_settlement, style: 'boldText'},], style: 'normalText' },
          { text: ['Settlement Option: ', {text: dataToSend.settlement_option, style: 'boldText'},], style: 'normalText' },

          { text: '\n\n Declaration:', style: 'heading' },
          { text:
            [
              'I hereby undertake to withdraw the present litigation and not to pursue the matter in any other forum in future. ',
              'I also undertake that in the event of non-compliance to any of the terms of this arrangement ',
              'at any point of time till payment of last instalment, entire amount paid under this scheme will be ',
              'forfeited and I will have no claim over it. ',
              'Requisite upfront payment of Rs.',
              {text: dataToSend.payment_amt, style: 'boldText'},
              ' is deposited to the designated APDCL Account ',
              '(Account No. 10566984122 maintained with SBI, New Guwahati Branch, IFS Code SBIN0000221) ',
              'vide [UTR/RTGS/NEFT Reference No.] : ',
              {text: dataToSend.payment_ref, style: 'boldText'},
            ],
             style: 'normalText'
           },

           { text: ['Date: ', {text: dataToSend.date, style: 'boldText'},], style: 'normalText' },
           { text: ['Place: ', {text: dataToSend.place, style: 'boldText'},], style: 'normalText' },
           { text: ['Applicant Name: ', {text: dataToSend.applicant_name, style: 'boldText'},], style: 'normalText' },


          { text: '\n\n Submission Date: ' + dateTime , style: 'footerText'},
             ],
             styles: {
                  header: {
                  fontSize: 15,
                  bold: true,
                  alignment: 'center',
                  margin: [0, 0, 0, 5]
              },
            subheader: {
                fontSize: 15,
                alignment: 'center',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            applNo: {
                fontSize: 13,
                alignment: 'center',
                color: '#0277bd',
                margin: [0, 10, 0, 5]
            },
            heading: {
                fontSize: 12,
                alignment: 'left',
                bold: true,
                margin: [0, 10, 0, 5]
            },
            normalText: {
                fontSize: 10,
                alignment: 'left',
                margin: [0, 10, 0, 5]
            },
            boldText: {
                fontSize: 11,
                alignment: 'left',
                bold:true,
                margin: [0, 10, 0, 5]
            },
            bottomText: {
                fontSize: 10,
                fontWeight: 600,
                alignment: 'left',
                margin: [0, 10, 0, 5]
            },
            footerText: {
                fontSize: 8,
                alignment: 'center',
                margin: [0, 10, 0, 5]
            },
            tableExample: {
                margin: [0, 5, 5, 0],
                alignment: 'left',
                fontSize: 10,
            }
        },

      };

      pdfMake.createPdf(docDefinition).download("Acknowledgement" +dataToSend.cons_no+ ".pdf");
      setTimeout(function(){ window.location.reload(); }, 2000);

    },
    showStatus()
    {
      var applNo=document.getElementById("applNo").value;
      if(applNo=="")
      {
        this.$bvToast.toast('Enter Application Number !', {
          title: `Alert`,
          variant: 'danger',
          solid: true
        })

        return;
    }

      var parent=this;
      this.show= true;
      axios.get(parent.$urlCommon + "/api/web/getAmicableStatus?applNo="+applNo)
      .then((response) => {
        parent.show= false;
        console.log(response.data);
        document.getElementById("statusDetails").classList.add("showDetails");
        document.getElementById("statusDiv").innerHTML=response.data.amicableStatus;
      })

    }
  }
}

</script>

<style scoped="true">
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  /* box-shadow: 2px 2px 10px 2px #bdbdbd; */
  padding: 1rem;
  margin-right: 1.5rem;
}
.showDetails
{

  visibility: visible;
 opacity: 1;
}
.sbtBtn
{
  pointer-events: none;
  background-color: grey;
}

.paddingRow{
  padding:0.7rem;
}
.paddingCol{
  padding: none;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.top{
  text-align: center;
  color:darkblue;
}
.hideDiv
{
   visibility: visible;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;

}
.showDiv
{

  visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}

.paddingLeft30px{
  padding-left: 30px;
}

@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
  }
@media only screen and (max-width: 414px) {
  .paddingCol{
    padding: 0.7rem;
  }
  .paddingRow{
    padding: none !important;
  }
  .paddingLeft30px{
    padding-left: 0px;
  }
}
.path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 0;
}
.path.circle {
  -webkit-animation: dash 0.9s ease-in-out;
  animation: dash 0.9s ease-in-out;
}
.path.line {
  stroke-dashoffset: 1000;
  -webkit-animation: dash 0.9s 0.35s ease-in-out forwards;
  animation: dash 0.9s 0.35s ease-in-out forwards;
}
.path.check {
  stroke-dashoffset: -100;
  -webkit-animation: dash-check 0.9s 0.35s ease-in-out forwards;
  animation: dash-check 0.9s 0.35s ease-in-out forwards;
}

p {
  text-align: center;
  margin: 20px 0 60px;
  font-size: 1.25em;
}
p.success {
  color: #73AF55;
}
p.error {
  color: #D06079;
}
@-webkit-keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes dash {
  0% {
    stroke-dashoffset: 1000;
  }
  100% {
    stroke-dashoffset: 0;
  }
}
@-webkit-keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}
@keyframes dash-check {
  0% {
    stroke-dashoffset: -100;
  }
  100% {
    stroke-dashoffset: 900;
  }
}

</style>
